import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	listItemTitle: {
		flex: 1,
		textTransform: "capitalize",
		lineHeight: "19px",
		wordWrap: "break-word"
	},
	icon: {
		width: "40px",
		height: "40px",
		color: themeColors.getPrimaryColor()
	}
}))

export default useStyles
